import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { catchError, EMPTY, Observable, Subject } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';

import { CourseGalleryCardComponent } from '../course-gallery-card/course-gallery-card.component';
import { CourseGalleryItemDTO } from '../../models/LearningPlanDTO';
import { CustomPortalError } from '../../../../../core/errors/models/CustomPortalError';
import { SnackbarService } from '../../../../../core/services/snackbar.service';
import { CourseGalleryService } from '../../services/course-gallery.service';
import { MatIcon } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { LearningPlanBuilderDataService } from '../../services/learning-plan-builder-data.service';

@Component({
  selector: 'app-learning-plan-course-selection-dialog',
  imports: [
    MatButtonModule,
    CourseGalleryCardComponent,
    MatIcon,
    TranslocoModule,
  ],
  templateUrl: './learning-plan-course-selection-dialog.component.html',
})
export class LearningPlanCourseSelectionDialogComponent
  implements OnInit, OnDestroy
{
  dialogRef =
    inject<MatDialogRef<LearningPlanCourseSelectionDialogComponent>>(
      MatDialogRef,
    );
  private readonly snackbarService = inject(SnackbarService);
  private readonly courseGalleryService = inject(CourseGalleryService);
  private readonly learningPlanDataService = inject(
    LearningPlanBuilderDataService,
  );
  data = inject<{
    topicAreaId: string | null;
  }>(MAT_DIALOG_DATA);

  private readonly destroy$: Subject<void> = new Subject();
  courseGalleryRes$: Observable<CourseGalleryItemDTO[]>;
  public selectedTopicAreaName: string | null = null;
  public courses: CourseGalleryItemDTO[] = [];

  isLoading = false;

  ngOnInit() {
    this.isLoading = true;
    this.courseGalleryRes$ = this.courseGalleryService
      .getCourses(this.data.topicAreaId)
      .pipe(
        catchError((error: CustomPortalError) => {
          this.snackbarService.error(error.errorType);
          this.isLoading = false;
          return EMPTY;
        }),
      );
    this.courseGalleryRes$.subscribe((courses) => {
      const disabledExternalMoodleIds = [44003]; // Contents of these courses are not yet ready in Moodle -> disabled for selection y users (to be removed later)
      this.courses = courses
        .filter(
          (course) =>
            !disabledExternalMoodleIds.includes(
              Number(course.externalMoodleId),
            ),
        )
        .sort(
          (a, b) => Number(a.externalMoodleId) - Number(b.externalMoodleId),
        );
      this.isLoading = false;
    });
    this.selectedTopicAreaName =
      this.learningPlanDataService.topicAreas.find(
        (topic) => topic.value === this.data.topicAreaId,
      )?.key ?? null;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  selectCourse(course: CourseGalleryItemDTO) {
    this.dialogRef.close(course);
  }

  onCloseBtnClick() {
    this.dialogRef.close();
  }
}
